import {
  Dialog,
  IconButton,
  makeStyles,
  Grid,
  TextField,
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import ButtonSp from '../ui/ButtonSp'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'next-i18next'

const useStyle = makeStyles(theme => ({
  modal: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing(5)}px ${theme.spacing(3)}px ${theme.spacing(3)}px ${theme.spacing(3)}px`,
    position: 'relative',
  },
  closeModal: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1)
  },
  button: {
    margin: `${theme.spacing(2)}px 0 0 0`,
    height: 50,
  },
  title: {
    fontWeight: 500,
    fontSize: 24,
    marginTop: 0,
    textAlign: 'center',
  },
  weightText: {
    fontWeight: 500,
    fontSize: 30,
    color: theme.palette.primary.main,
    margin: `0 ${theme.spacing(1)}px`,
  },
}))

const CalWeightModal = ({ open, onClose, setWeight }) => {
  const { register, handleSubmit, watch } = useForm()
  const calculateWeight = () => {
    return (
      parseFloat(watch('width') || 0) *
      parseFloat(watch('long') || 0) *
      parseFloat(watch('height') || 0) *
      0.2
    ).toFixed(0)
  }

  const classes = useStyle()
  const { t } = useTranslation('checkprice')

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="modal-calculate-weight"
      maxWidth="sm"
      scroll="body"
      fullWidth
    >
      <div className={classes.modal}>
        <IconButton className={classes.closeModal} onClick={onClose}>
          <CloseIcon />
        </IconButton>
        <p className={classes.title}>{t('estimate-weight')}</p>
        <form onSubmit={
          handleSubmit(() => {
            setWeight(calculateWeight())
            onClose()
          })
        }>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                label={t('width-cm')}
                name="width"
                inputRef={register}
                type="number"
                variant="outlined"
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label={t('length-cm')}
                name="long"
                inputRef={register}
                type="number"
                variant="outlined"
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label={t('height-cm')}
                name="height"
                inputRef={register}
                type="number"
                variant="outlined"
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <p style={{ margin: 0, }}>
                {t('estimated-weight')}{' '}
                <span className={classes.weightText}>
                  {calculateWeight() || 0}
                </span>{' '}
                {t('gram')}
              </p>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <ButtonSp
                color="default"
                className={classes.button}
                onClick={() => onClose()}
                fullWidth
              >
                {t('cancel')}
              </ButtonSp>
            </Grid>
            <Grid item xs={6}>
              <ButtonSp
                type="submit"
                className={classes.button}
                fullWidth
              >
                {t('ok')}
              </ButtonSp>
            </Grid>
          </Grid>
        </form>
      </div>
    </Dialog>
  )
}

export default CalWeightModal
